import * as z from "zod";
// avoid using the shared config in the web and twa unless necessary

const SharedEnvSchema = z.object({
  APP_ENV: z.string().optional(), // only for mobileapp
  API_URL: z.string(),
  EXPO_PUBLIC_API_URL: z.string().optional(),
  DEV: z
    .string()
    .refine((s) => s === "true" || s === "false")
    .optional()
    .default("false")
    .transform((s) => s === "true"),
});

export type SharedEnv = z.infer<typeof SharedEnvSchema>;

const createEnv = (): SharedEnv => {
  // React Native環境では import.meta が使用できないため、別の方法を使用
  const isReactNative =
    typeof window !== "undefined" &&
    typeof window.navigator !== "undefined" &&
    window.navigator.product === "ReactNative";

  let envSource: Record<string, string | undefined>;

  if (isReactNative) {
    try {
      // React Native環境では Expo Constants を使用
      const moduleName = "expo-constants";
      const Constants = require(moduleName).default;
      envSource = Constants.expoConfig?.extra || {};
    } catch (error) {
      console.warn("Could not load expo-constants, falling back to process.env");
      envSource = process.env as Record<string, string | undefined>;
    }
  } else if (typeof process !== "undefined") {
    // Node.js環境
    envSource = process.env as Record<string, string | undefined>;
  } else if (typeof import.meta !== "undefined" && (import.meta as any).env) {
    // Web環境（Vite）
    envSource = (import.meta as any).env as Record<string, string | undefined>;
  } else {
    // Fallback
    envSource = {};
  }

  const envVars = Object.entries(envSource).reduce<Record<string, string>>((acc, curr) => {
    const [key, value] = curr;
    if (key.startsWith("FARM_") && value !== undefined) {
      acc[key.replace("FARM_", "")] = value;
    } else if (key === "APP_ENV" && value !== undefined) {
      // APP_ENV is not prefixed with FARM_ but should be included
      acc[key] = value;
    }
    return acc;
  }, {});

  const parsedEnv = SharedEnvSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error("Invalid shared env provided");
  }

  return parsedEnv.data;
};
export const env = createEnv();
